import { AlertCircle } from 'lucide-react';
import { Button } from '@/components/ui/Button';

/** Full-screen branded loader for application boot (and optional blocking tasks). */
export function GlobalLoader({
  error = false,
  onRetry,
  label = 'Starting Ezzo Admin…',
}: {
  error?: boolean;
  onRetry?: () => void;
  label?: string;
}) {
  return (
    <div
      className="global-loader"
      role="status"
      aria-live="polite"
      aria-busy={!error}
      aria-label={error ? 'Startup failed' : label}
    >
      <div className="global-loader-card">
        <div className="global-loader-mark" aria-hidden>
          E
        </div>
        <div className="global-loader-brand">Ezzo Admin</div>
        {error ? (
          <>
            <p className="global-loader-error">
              <AlertCircle size={16} aria-hidden /> Could not finish starting up.
            </p>
            {onRetry ? (
              <Button variant="secondary" size="sm" onClick={onRetry}>
                Try again
              </Button>
            ) : null}
          </>
        ) : (
          <>
            <p className="global-loader-label">{label}</p>
            <div className="global-loader-bar" aria-hidden>
              <i />
            </div>
          </>
        )}
      </div>
    </div>
  );
}
